export const getAmountToPay = (invoice: {
  amount: number;
  minimumAmount?: number;
  paymentIsMinimum: boolean;
  partialAmount?: number;
}) => invoice.partialAmount ?? ((invoice.paymentIsMinimum && invoice.minimumAmount) || invoice.amount);
